import { NgIf, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-sk-test-checkbox',
  templateUrl: './sk-test-checkbox.component.html',
  styleUrls: ['./sk-test-checkbox.component.less'],
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
  imports: [ReactiveFormsModule, NgIf, NgStyle]
})
export class SkTestSpecificationCheckboxComponent implements OnInit {

  @Input() name: string;
  @Input() label: string;
  @Input() labelBold: boolean;
  @Input() code: string;
  @Input() codeBold: boolean;
  @Input() codeWidth: string = '100px';

  constructor() { }

  ngOnInit() {
  }

}
